import ActionType from '../action-types';

const initialState = {
  loading: false,
  error: null,
  success: false,
  designation: []
};

// eslint-disable-next-line default-param-last
const designationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.FETCH_DESIGNATION_START:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
        designation: null
      };
    case ActionType.FETCH_DESIGNATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        designation: action.payload.data
      };
    case ActionType.FETCH_DESIGNATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
        designation: null
      };
    default:
      return state;
  }
};

export default designationReducer;
